var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "class",
    title: "CSS Class",
    description: "Validates a space-separated string or array of valid CSS class names.",
    type: "field",
    use: {
        namespace: "ua.text"
    },
    tests: {
        validString: {
            must: true,
            run: function () {
                return validate({}, "btn btn-primary alert");
            }
        },
        validArray: {
            must: true,
            run: function () {
                return validate({}, ["alert", "alert-warning"]);
            }
        },
        invalidEntry: {
            throw: "fields.class.invalid",
            run: function () {
                return validate({}, ["alert", "bad class"]);
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Class Name",
            description: "Class names must be valid CSS identifiers (letters, digits, dashes, underscores).",
            template: "Invalid class: ${value}"
        }
    }
});

function check(name) {
    if (typeof name !== "string" || !/^[a-zA-Z0-9_-]+$/.test(name)) {
        _.errors.invalid.throw({ value: name });
    }
}


function validate(spec, value) {
    if (typeof value === "string") {
        var parts = value.split(" ");
        for (var i = 0; i < parts.length; i++) {
            if (parts[i].trim() !== "") check(parts[i].trim());
        }
    } else if (Array.isArray(value)) {
        for (var j = 0; j < value.length; j++) {
            check(value[j]);
        }
    } else {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;


/**
 * Creates a class list from a string, array, or object.
 * @param {*} classes The classes to create a class list from.
 * Can be a string (space-separated), an array of class names, or an object where
 * @returns {Array} An array of class names.
 */
function create(classes) {
  if (typeof classes === "string") {
    // If it's a string, split by spaces and return as an array
    return classes.split(/\s+/).filter(Boolean);
  }  else if (Array.isArray(classes)) {
    // If it's an array, return it as is
    return classes;
  } else if (typeof classes === "object" && classes !== null) {
    // If it's an object, extract keys as class names
    return Object.keys(classes).filter(key => classes[key]);
  } else {
    // If it's not a string, array, or object, return an empty array
    throw new TypeError("Invalid type for classes: " + typeof classes);
  }
} module.exports.create = create;

/**
 * Merges multiple class lists into a single array of unique class names.
 * @param  {...any} classLists 
 * @returns {Array} An array of unique class names.
 */
function merge(...classLists) {

    //conform to the createClassList function
    if (classLists.length === 0) {
        return [];
    }

    if (classLists.length > 1) {
        for (let i = 0; i < classLists.length; i++) {
            classLists[i] = create(classLists[i]);
        }
    }

  const mergedClasses = new Set();
  classLists.forEach(classes => {
    create(classes).forEach(className => {
      if (className) {
        mergedClasses.add(className);
      }
    });
  });
  return Array.from(mergedClasses)
} module.exports.merge = merge;